/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

const enum fields {
    horizontalTextAlignment = "horizontalTextAlignment",
    marginAllSide = "marginAllSide",
    textTransform = "textTransform",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.horizontalTextAlignment]: "left" | "center" | "right";
        [fields.marginAllSide]: string;
        [fields.textTransform]: "capitalize" | "uppercase" | "lowercase" |  "none";
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => {
    let shouldNotRender: any;
    if (typeof window !== "undefined") {
        shouldNotRender = window?.location?.pathname?.includes("MyAccount") ? "display:none;" :"display:block;";
    }
    
    const titleStyle = {
        css: css`
            text-align: ${fields.horizontalTextAlignment};
            text-transform: ${ fields.textTransform};
            font-size: ${TYPOGRAPHY.size.xxlarge};
            line-height: ${TYPOGRAPHY.lineHeight.xlmedium};
            margin: ${fields.marginAllSide};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            color: ${getColor("text.main")} !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        ${shouldNotRender}
                        margin-bottom: 15px;
                    `,
                    css`
                        ${shouldNotRender}
                        margin-bottom: 15px;
                    `,
                    css`
                        ${shouldNotRender}
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    };
    return (
        <Typography as="h1" data-test-selector="PageTitle" {...titleStyle}>
            {pageTitle || ""}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.marginAllSide,
                displayName: "Margin",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.horizontalTextAlignment,
                editorTemplate: "DropDownField",
                defaultValue: "left",
                fieldType: "General",
                options: [
                    { displayName: "Left", value: " left" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "right" },
                ],
            },
            {
                name: fields.textTransform,
                editorTemplate: "DropDownField",
                defaultValue: "none",
                fieldType: "General",
                options: [
                    { displayName: "Capitalize", value: "capitalize" },
                    { displayName: "Uppercase", value: "uppercase" },
                    { displayName: "Lowercase", value: "lowercase" },
                    { displayName: "None", value: "none" },
                ],
            },
            
        ],
    },
};

export default widgetModule;
